/* eslint-disable */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import { useDropzone } from 'react-dropzone';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { DataGrid } from '@mui/x-data-grid';
import HighlightOffRoundedIcon from '@mui/material/Icon';
import { AppBar, Box, Icon, Tab, Tabs, Typography, IconButton, TextField, Button, MenuItem, Checkbox, FormControl, InputLabel, Select, ListItemText } from "@mui/material";
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddIcon from '@mui/icons-material/Add';
import FormHelperText from '@mui/material/FormHelperText';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/all-tasks-view/data/authorsTableData";
import tasksViewTableData from "layouts/all-tasks-view/data/tasksViewTableData";
import tasksViewDataGrid from "layouts/all-tasks-view/data/tasksViewDataGrid";
import { toast } from "react-toastify";
import { AllInbox, CallMadeRounded, CallReceivedRounded, DirectionsCar, Diversity2Rounded, EditNote, MarkAsUnread, Newspaper, RocketLaunchRounded, Work, WorkOutline, WorkOutlineRounded } from "@mui/icons-material";

function Tables() {
  const [tasksType, setTasksType] = useState(() => {
    const data = localStorage.getItem("tasksType");
    return data !== null ? data : "tasks-asigned-to-me";
  });
  const [tasksData, setTasksData] = useState([]);
  const [tasksDataSorted, setTasksDataSorted] = useState([]);
  const [tabValue, setTabValue] = useState(() => {
    return localStorage.getItem("websiteTabType") !== null ? parseInt(localStorage.getItem("websiteTabType")) : 0;
  });
  const [updateTasksData, setUpdateTasksData] = useState(0);
  // const { columns: pColumns, rows: pRows } = tasksViewTableData(tasksData, setUpdateTasksData);
  // const reversedRows = [...pRows].reverse();
  const { columns: pDataGridColumns, rows: pDataGridRows } = tasksViewDataGrid(tasksDataSorted, setUpdateTasksData);
  const [isAdmin, setIsAdmin] = useState(true);

  // Menu
  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("websiteTabType", newValue);
  }

  useEffect(() => {
    getUserID();
  }, []);

  const getAllTasksShort = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShort");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShort List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShort List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortToWorkerMe = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortToWorkerMe");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortToWorkerMe List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortToWorkerMe List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortCreatedByMe = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortCreatedByMe");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortCreatedByMe List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortCreatedByMe List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortToMyDepartment = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortToMyDepartment");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortToMyDepartment List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortToMyDepartment List. ${error}`);
      setTasksData([]);
    }
  };

  const getUserID = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getUserID");
      const data = await response.json();
      data.status !== "fakeUser" && setIsAdmin(data.is_admin);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AccountID: ", error);
      toast.error("Błąd podczas pobierania danych z serwera AccountID", error);
    }
  };

  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    sessionStorage.setItem("currentPage", newPage);
    console.log("currentPage is "+newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    // setPageSize(newPageSize);
    sessionStorage.setItem('pageSize', newPageSize);
    console.log("pageSize is "+newPageSize);
  };



  //Katalogi
  const [catalogName, setCatalogName] = useState('');
  const [catalogDescription, setCatalogDescription] = useState('');
  const [catalogImage, setCatalogImage] = useState(null);
  const [catalogAltImage, setCatalogAltImage] = useState('');
  const [catalogPdf, setCatalogPdf] = useState(null);
  const [categories, setCategories] = useState(["Zima", "Lato"]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');

  const onDropImage = (acceptedFiles) => {
    setCatalogImage(acceptedFiles[0]);
  };

  const onDropPdf = (acceptedFiles) => {
    setCatalogPdf(acceptedFiles[0]);
  };

  const { getRootProps: getImageRootProps, getInputProps: getImageInputProps } = useDropzone({
    onDrop: onDropImage,
    accept: 'image/*'
  });

  const { getRootProps: getPdfRootProps, getInputProps: getPdfInputProps } = useDropzone({
    onDrop: onDropPdf,
    accept: 'application/pdf'
  });

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setSelectedCategories(typeof value === 'string' ? value.split(',') : value);
  };

  const handleAddCategory = () => {
    if (newCategory.trim() !== '') {
      axios.post('/api/categories', { name: newCategory })
        .then(response => {
          setCategories([...categories, response.data]);
          setNewCategory('');
        })
        .catch(error => {
          console.error('Error adding category:', error);
        });
    }
  };

  const handleSubmit = async () => {
    // Add logic to handle form submission
    console.log('Catalog Name:', catalogName);
    console.log('Catalog Description:', catalogDescription);
    console.log('Catalog Image:', catalogImage);
    console.log('Catalog PDF:', catalogPdf);
    console.log('Selected Categories:', selectedCategories);

    const formData = new FormData();
    formData.append('catalogName', catalogName);
    formData.append('catalogDescription', catalogDescription);
    formData.append('catalogImage', catalogImage);
    formData.append('catalogAltImage', catalogAltImage);
    formData.append('catalogPdf', catalogPdf);
    formData.append('selectedCategories', JSON.stringify(selectedCategories));

    try {
      const response = await fetch('https://devcolibri.pl/helpdesk-example/php/api/common-api.php/uploadCatalog', {
        method: 'POST',
        body: JSON.stringify(catalogName),
      });
  
      const result = await response.json();
      if (result.ok) {
        toast.success('Katalog został pomyślnie dodany!');
        // Opcjonalnie, zresetuj formularz po pomyślnym dodaniu katalogu
        // setCatalogName('');
        // setCatalogDescription('');
        // setCatalogImage(null);
        // setCatalogAltImage('');
        // setCatalogPdf(null);
        // setSelectedCategories([]);
      } else {
        toast.error('Wystąpił błąd podczas dodawania katalogu.'+result);
        console.log('odp: '+ result);
        console.log(result);
      }
    } catch (error) {
      console.error('Błąd podczas wysyłania katalogu:', error);
      toast.error('Wystąpił błąd podczas wysyłania katalogu.'+ error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  Zadania
                </MDTypography>
              </MDBox> */}
              <MDBox mx={2} mt={0} py={3} px={2}>
                {/* <FormControl fullWidth sx={{ width: 1/2 }}>
                  <InputLabel id="tasks-type">Rodzaj zadania</InputLabel>
                  <Select
                    labelId="tasks-type"
                    id="tasks-type-select"
                    variant="standard"
                    value={tasksType}
                    label="Priorytet"
                    onChange={handleChangeTasksType}
                  >
                    <MenuItem value="tasks-asigned-to-me"><CallReceivedRounded fontSize="medium"/>Przypisane do mnie</MenuItem>
                    <MenuItem value="tasks-asigned-to-my-department"><Diversity2Rounded fontSize="medium"/>Przypisane do mojego działu</MenuItem>
                    {
                      isAdmin && <MenuItem value="all-tasks"><AllInbox fontSize="medium"/>Wszystkie zadania</MenuItem>
                    }
                    <MenuItem value="tasks-created-by-me"><CallMadeRounded fontSize="medium"/> Utworzone przeze mnie</MenuItem>
                  </Select>
                </FormControl> */}
                <Box mt={3}>
                  <AppBar position="static">
                    <Tabs orientation="horizontal" value={tabValue} onChange={handleSetTabValue}>
                      <Tab
                        label="Banner"
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            photo_library
                          </Icon>
                        }
                      />
                      <Tab
                        label="Katalogi"
                        icon={
                          <Newspaper fontSize="medium" /> 
                        }
                      />
                      <Tab
                        label="Blog"
                        icon={
                          <EditNote fontSize="medium" />
                        }
                      />
                      <Tab
                        label="Newsletter"
                        icon={
                          <MarkAsUnread fontSize="medium" />
                        }
                      />
                      <Tab
                        label="Oferty pracy"
                        icon={
                          <WorkOutlineRounded fontSize="medium" />
                        }
                      />
                      <Tab
                        label="Samochody"
                        icon={
                          <DirectionsCar fontSize="medium" />
                        }
                      />
                    </Tabs>
                  </AppBar>
                </Box>
              </MDBox>
              
              {/* <MDBox pt={0}>
                <DataTable table={{ columns: pColumns, rows: reversedRows }} isSorted={false} entriesPerPage={false} showTotalEntries={true} />
              </MDBox> */}
              <MDBox pt={0}>
                {/* <DataGrid columns={pDataGridColumns} rows={pDataGridRows.reverse()} 
                  // checkboxSelection
                  // disableClickEventBubbling={true}
                  // cellSelection={false}
                  rowSelection={false}
                  columnHeaderHeight={40}
                  initialState={{
                    pagination: { 
                      paginationModel: { 
                        pageSize: sessionStorage.getItem("pageSize") ? parseInt(sessionStorage.getItem("pageSize")) : 10,
                        page: sessionStorage.getItem("currentPage") ? parseInt(sessionStorage.getItem("currentPage")) : 0
                      } 
                    },
                  }}
                  pageSizeOptions={[5, 10, 25, 100]} 
                  onPageChange={(params) => handlePageChange(params.page)}
                  onPageSizeChange={(params) => handlePageSizeChange(params.pageSize)}

                  onPaginationModelChange={(params) => {
                    handlePageChange(params.page);
                    handlePageSizeChange(params.pageSize);
                  }}
                  /> */}
              </MDBox>

              {tabValue === 1 && (
                <MDBox mx={2} mt={0} mb={3} py={0} px={2}>
                <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
                  <Typography variant="h4" gutterBottom>
                    Dodaj nowy katalog
                  </Typography>
                  <TextField
                    fullWidth
                    label="Nazwa katalogu"
                    value={catalogName}
                    onChange={(e) => setCatalogName(e.target.value)}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Opis katalogu (Opcjonalne)"
                    value={catalogDescription}
                    onChange={(e) => setCatalogDescription(e.target.value)}
                    multiline
                    rows={4}
                    sx={{ mb: 2 }}
                  />

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel sx={{ marginTop: '-10px' }}>Kategorie</InputLabel>
                    <Select
                      multiple
                      value={selectedCategories}
                      onChange={handleCategoryChange}
                      renderValue={(selected) => selected.join(', ')}
                      sx={{ height: '40px' }}
                    >
                      {categories.map((category) => (
                        <MenuItem key={category} value={category}>
                          <Checkbox checked={selectedCategories.indexOf(category) > -1} />
                          <ListItemText primary={category} />
                        </MenuItem>
                      ))}
                      <MenuItem>
                        <TextField
                          value={newCategory}
                          onChange={(e) => setNewCategory(e.target.value)}
                          placeholder="Nowa kategoria"
                          fullWidth
                        />
                        <IconButton onClick={handleAddCategory}>
                          <AddIcon />
                        </IconButton>
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <Box {...getImageRootProps()} sx={{ border: '2px dashed gray', p: 2, mb: 2, textAlign: 'center' }}>
                    <input {...getImageInputProps()} />
                    {catalogImage ? (
                      <Typography>{catalogImage.name}</Typography>
                    ) : (
                      <Box>
                        <IconButton>
                          <AddAPhotoIcon />
                        </IconButton>
                        <Typography>Przeciągnij tutaj zdjęcie katalogu lub kliknij, aby wybrać</Typography>
                      </Box>
                    )}
                  </Box>
                  <TextField
                    fullWidth
                    label="Nazwa alternatywna obrazka (SEO)"
                    value={catalogName}
                    onChange={(e) => setCatalogAltImage(e.target.value)}
                    sx={{ mb: 2 }}
                  />
                  <Box {...getPdfRootProps()} sx={{ border: '2px dashed gray', p: 2, mb: 2, textAlign: 'center' }}>
                    <input {...getPdfInputProps()} />
                    {catalogPdf ? (
                      <Typography>{catalogPdf.name}</Typography>
                    ) : (
                      <Box>
                        <IconButton>
                          <PictureAsPdfIcon />
                        </IconButton>
                        <Typography>Przeciągnij tutaj plik PDF katalogu lub kliknij, aby wybrać</Typography>
                      </Box>
                    )}
                  </Box>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button variant="contained" color="primary" style={{ color: 'white' }} onClick={handleSubmit}>
                      Dodaj katalog
                    </Button>
                  </Box>
                </Box>
              </MDBox>

              )}

              
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
